// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the rails generate channel command.

// Please do not use this unless absolutely necessary.

const ActionCable = require("@rails/actioncable");

const url = window.location.origin + "/api/cable";
App.cable = ActionCable.createConsumer(url);
